export default __webpack_public_path__ + "static/media/menu_white_24dp.f8235882.svg";